// #ifndefall OPEN-SOURCE
/*
 * @Author: your name
 * @Date: 2021-07-13 14:49:11
 * @LastEditTime: 2022-06-10 15:33:21
 * @LastEditors: LAPTOP-JM4BAR46
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\router\center-setting\stock.js
 */
/*
 * -库存配置
 */

import EmptyRouter from '@/layout/EmptyRouter.vue';
import EmptyRouterAlive from '@/layout/EmptyRouterAlive.vue';
// import Test0Empty from '@/views/test/empty.vue';
export default {
  path: 'stock',
  name: 'SettingStock',
  component: EmptyRouterAlive,
  meta: {
    title: '库存',
  },
  children: [
    /** 仓库结构配置 */
    {
      path: 'structure',
      name: 'SettingStockStructure',
      redirect: 'structure/list',
      component: EmptyRouter,
      meta: {
        title: '仓库结构配置',
      },
      children: [
        {
          path: 'list',
          name: 'SettingStockStructure',
          component: () => import('@/views/center-setting/stock/structure/index'),
          meta: {
            title: '仓库结构配置',
          },
        },
        {
          path: 'view',
          name: 'SettingStockStructureView',
          component: () => import('@/views/center-setting/stock/structure/view'),
          meta: {
            title: '仓库结构配置详情',
          },
          hidden: true,
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingStockStructureIndex_Set',
          meta: {
            title: '配置-仓库结构配置',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingStockStructureIndex_Close',
          meta: {
            title: '下架-仓库结构配置',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingStockStructureIndex_Release',
          meta: {
            title: '发布-仓库结构配置',
          },
          hidden: true,
        },
        {
          path: '',
          name: 'SettingStockStructureIndex_Delete',
          meta: {
            title: '删除-仓库结构配置',
          },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    /** 仓库结构配置end */
    {
      path: 'ratio',
      name: 'SettingStockRatio',
      redirect: 'ratio/config',
      component: EmptyRouter,
      meta: {
        title: '库存比例配置',
      },
      children: [
        {
          path: 'config',
          name: 'SettingStockRatioConfig',
          component: () => import('@/views/center-setting/stock/ratio/index.vue'),
          meta: {
            title: '库存比例配置',
          },
        },
        {
          path: '',
          name: 'SettingStockRatioConfig_Set',
          meta: {
            title: '设置-库存比例',
          },
        },
      ],
    },
    /** 库存审核策略 */
    {
      path: 'audit',
      name: 'SettingStockAudit',
      redirect: 'audit/strategy',
      component: EmptyRouter,
      meta: {
        title: '库存审核策略',
      },
      children: [
        {
          path: 'strategy',
          name: 'SettingStockAudit',
          component: () => import('@/views/center-setting/stock/audit/strategy.vue'),
          meta: {
            title: '库存审核策略',
          },
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingStockAuditStrategy_Save',
          meta: {
            title: '保存-库存审核策略',
          },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    /** 库存规则 */
    {
      path: 'rules',
      name: 'SettingStockRules',
      component: EmptyRouter,
      redirect: 'rules/config',
      meta: {
        title: '库存规则',
      },
      children: [
        {
          path: 'config',
          name: 'SettingStockRules',
          component: () => import('@/views/center-setting/stock/rules'),
          meta: {
            title: '库存规则',
          },
        },
        /** 按钮权限start */
        {
          path: '',
          name: 'SettingStockRulesConfig_Save',
          meta: {
            title: '保存-库存规则',
          },
          hidden: true,
        },
        /** 按钮权限end */
      ],
    },
    /** 库存规则end */

    /* ******************************  暂时不显示  *******************************/
    /** 库存流程配置 */
    // {
    //   path: 'process',
    //   name: 'SettingStockProcess',
    //   redirect: 'process/list',
    //   component: EmptyRouter,
    //   meta: {
    //     title: '库存流程配置',
    //   },
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'SettingStockProcessList',
    //       component: () => import('@/views/center-setting/stock/process'),
    //       meta: {
    //         title: '库存流程配置',
    //       },
    //     },
    //     {
    //       path: 'view',
    //       name: 'SettingStockProcessView',
    //       component: () => import('@/views/center-setting/stock/process/view'),
    //       meta: {
    //         title: '库存流程配置详情',
    //       },
    //       hidden: true,
    //     },
    //   ],
    // },

    /* ******************************  暂时不显示  *******************************/
    /** 库存流程配置end */
    // {
    //   path: 'init',
    //   name: 'SettingStockInit',
    //   redirect: 'init/list',
    //   component: EmptyRouter,
    //   meta: {
    //     title: '库存初始化',
    //   },
    //   children: [
    //     {
    //       path: 'list',
    //       name: 'SettingStockInitList',
    //       component: () => import('@/views/center-setting/stock/init'),
    //       meta: {
    //         title: '库存初始化',
    //       },
    //     },
    //   ],
    // },
  ],
};
